import FlashMessageStore from "@shared/svelte/Stores/FlashMessageStore";

/* Usage
 * - To import the service
 *
 *   import Flash from '@shared/services/flashv2.js';
 *
 * - Flash.now will immediately display a flash message. Accepted types are:
 *     warning info error success
 *
 *   Flash.now({ type: 'info', header: 'Hello World', message: 'Welcome to Provi!' })
 *
 * - The compact option will place the header and message on the same line
 *
 *   Flash.now({ compact: true, type: 'info', header: 'Hello World', message: 'Welcome to Provi!' })
 *
 * - The small option will add the class 'fizz-alert--small'
 *
 *   Flash.now({ small: true, type: 'info', header: 'Hello World', message: 'Welcome to Provi!' })
 *
 * - The rawHtml option will cause the message and header to not have HTML escaped.
 * !! It could be dangerous to use this option in combination with user-inputted values
 *
 *   Flash.now({ rawHtml: true, type: 'info', header: 'Hello World',
 *     message: 'Welcome to Provi! Click <a href="#hs-open-chat">here</a> for the live chat.' })
 *
 * - Use Flash.queue to display a flash message on the next UI router state change success.
 *
 *   Flash.queue({ type: 'info', header: 'Order Submitted', message: 'Your order was submitted!' })
 *
 * - Use Flash.clear() to remove any currently displayed messages.
 */

let flashMessageQueue = [];

let validate = function (message) {
  if (["warning", "info", "error", "success"].indexOf(message.type) == -1) {
    throw `Unknown Flash type ${message.type}`;
  }
};

let now = function (message) {
  validate(message);
  FlashMessageStore.update(n => {
    n.push(message);
    return n;
  });
  FlashMessageStore.update(n => {
    return n;
  });
};

let queue = function (message) {
  validate(message);
  flashMessageQueue.push(message);
};

let showQueuedMessages = function () {
  FlashMessageStore.update(n => [...n, ...flashMessageQueue]);
  flashMessageQueue = [];
};

let clear = function () {
  FlashMessageStore.update(n => []);
};

export default { now, queue, showQueuedMessages, clear };
